/**
 * @file: useFetchServiceRecord.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { useServiceFactory } from '@euler/services/factory';

export const useFetchServiceRecord = (id: string) => {
  const { serviceRecordService } = useServiceFactory();
  return useCachedQuery(`service-records/details/${id}.json`, 0, () =>
    serviceRecordService.getServiceRecordById(id, {
      items: true,
      events: true,
      pendingIssues: true,
      troubleCodes: true,
      comment: true,
    }),
  );
};
